import React from 'react';
import { observer } from 'mobx-react';
import Header from '@organisms/common/Header';
import Footer from '@organisms/common/Footer';
import HiddenElement from '@molecules/HiddenElement';

function DefaultLayout({ children }) {
  return (
    <>
      <Header />
      <HiddenElement>{children}</HiddenElement>
      <HiddenElement>
        <Footer />
      </HiddenElement>
    </>
  );
}

export default observer(DefaultLayout);
